<template>
  <!-- 新建服务项目 -->
  <el-dialog class="dialog-add-activity" :title="pageType === 'add' ? '新建招募活动' : pageType === 'edit' ? '编辑招募活动':'服务项目详情'" @close="cancel"
             :visible.sync="dialogVisible" width="1200px">
    <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-col :span="24">
            <el-form-item v-if="serviceType == 2" label="讲解名称 :" prop="serviceName">
              <el-input v-model="form.serviceName" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="serviceType==3 ? '活动名称 :':'展览名称 :'" prop="exhibitionName">
              <el-input v-model="form.exhibitionName" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="serviceType==3 ? '活动地点 :':'展厅位置 :'" prop="serviceLocation">
              <el-input v-model="form.serviceLocation" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="服务时间 :" prop="serviceTimeBegin">
              <el-date-picker class="w-100" v-model="value1" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
                              :picker-options="pickerOptionsStart" :disabled="pageType === 'detail'" type="datetimerange" @change="timeChange"
                              start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
              <!-- <el-date-picker style="width: 220px;" :disabled="pageType === 'detail'" v-model="form.serviceTimeBegin"
                format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime"
                placeholder="选择日期时间"></el-date-picker>
              <span class="ml-10 mr-10">-</span>
              <el-date-picker style="width: 220px;" :disabled="pageType === 'detail'" v-model="form.serviceTimeEnd"
                format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime"
                placeholder="选择日期时间"></el-date-picker> -->
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="serviceType != 4">
            <el-form-item :label="serviceType==3 ? '活动时长（h） :':'讲解时长（h） :'" prop="serviceDuration">
              <el-input v-model="form.serviceDuration" placeholder="输入服务时间自动获取" disabled></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="招募类型 :" prop="recruitmentType">
              <el-checkbox-group v-model="recruitmentType">
                <el-checkbox v-for="(item, index) in typeList" @change="recruitmentTypeChange" :label="item.dictCode"
                             :key="index">{{item.dictName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="24">
            <el-form-item label="讲解时长 :" prop="explainNum">
              <el-input v-model="form.explainNum" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col> -->

          <el-col :span="24" v-if="serviceType == 4">
            <el-form-item label="要求场次 :" prop="explainNum">
              <el-input v-model="form.explainNum" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-else>
            <el-form-item :label="serviceType==3 ? '折合讲解场次 :':'讲解场次 :'" prop="explainNum">
              <el-input v-model="form.explainNum" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="招募名额 :" prop="quota">
              <el-input v-model.number="form.quota" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="报名截止 :" prop="deadlineTime">
              <el-date-picker style="width: 100%" :disabled="pageType === 'detail'" v-model="form.deadlineTime" format="yyyy-MM-dd HH:mm"
                              value-format="yyyy-MM-dd HH:mm" type="datetime" 
                              placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col v-if="serviceType == 3" :span="24">
            <el-form-item label="活动内容 :" prop="content">
              <el-input type="textarea" v-model="form.content" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>
        </el-col>

        <el-col :span="8">
          <el-form-item class="avatar-uploader-form" :label="serviceType == 2 ? '讲解封面' : serviceType == 3 ? '活动封面': '临展封面'" prop="mainPic">
            <div class="uploader-form" @click="uploadPicture(1)">
              <img v-if="form.mainPic" :src="form.mainPic" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div class="tip-img">建议图片大小：375 * 215</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="footer mt-30">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
    </cropper-image>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import CropperImage from '@cmp/cropper'
export default {
  components: { CropperImage },
  data() {
    const validateFile = (rule, value, callback) => {
      if (!this.form.mainPic) {
        callback(new Error('讲解封面不能为空'))
      } else {
        callback()
      }
    }
    const validateTime = (rule, value, callback) => {
      if (!this.form.serviceTimeBegin || !this.form.serviceTimeEnd) {
        callback(new Error('服务时间不能为空'))
      } else {
        callback()
      }
    }
    return {
      loadingSave: false,
      pageType: '', // 页面类型 add 新增 edit 编辑 detail 查看
      detailId: '', // 详情id
      serviceType: '',
      dialogVisible: false,
      recruitmentType: [],
      value1: [],
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.value1 && this.value1.length > 0) {
            let beginDateVal = this.value1[0]
            if (beginDateVal) {
              return time.getTime() > new Date(beginDateVal).getTime() - 8.64e7
            }
          }
        }
      },

      pickerOptionsStart: {
        startDate: null,
        disabledDate: (time) => {
          if (
            this.pickerOptionsStart.startDate === undefined ||
            this.pickerOptionsStart.startDate === null
          ) {
            if (this.form.deadlineTime) {
              return (
                time.getTime() <
                new Date(this.form.deadlineTime).getTime() + 8.64e7
              )
            } else {
              return null
            }
            // return time.getTime() > Date.now()
          } else {
            if (this.serviceType == 4) {
              return null
            }
            return (
              time.getTime() >
                this.pickerOptionsStart.startDate.getTime() + 86399000 ||
              time.getTime() < this.pickerOptionsStart.startDate.getTime()
            )
          }
        },
        onPick: (dateRange) => {
          this.pickerOptionsStart.startDate = dateRange.minDate
          if (dateRange.maxDate) {
            this.pickerOptionsStart.startDate = null
          }
        }
      },

      form: {
        serviceName: '',
        exhibitionName: '',
        recruitmentType: '',
        serviceTimeBegin: '',
        serviceTimeEnd: '',
        serviceDuration: '',
        serviceLocation: '',
        explainNum: '',
        quota: '',
        mainPic: '',
        deadlineTime: ''
      },
      rules: {
        serviceName: [{ required: true, message: '必填', trigger: 'blur' }],
        exhibitionName: [{ required: true, message: '必填', trigger: 'blur' }],
        explainNum: [{ required: true, message: '必填', trigger: 'blur' }],
        recruitmentType: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        serviceTimeBegin: [
          { required: true, validator: validateTime, trigger: 'change' }
        ],
        serviceTimeEnd: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        serviceLocation: [{ required: true, message: '必填', trigger: 'blur' }],
        quota: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            type: 'number',
            message: '必须为数字',
            trigger: 'blur'
          }
        ],
        mainPic: [
          { required: true, validator: validateFile, trigger: 'change' }
        ],
        deadlineTime: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      typeList: []
    }
  },
  methods: {
    calculateHours(startTime, endTime) {
      const diff = moment(endTime).diff(moment(startTime))
      const duration = moment.duration(diff)
      let hours = duration.asHours()
      this.form.serviceDuration = hours.toFixed(1)
    },
    init(type, detailId, serviceType) {
      this.pageType = type // add 新增 edit 编辑 detail 查看
      this.detailId = detailId || ''
      this.serviceType = serviceType

      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })

      this.setTypeList()
      this.dialogVisible = true
      if (this.detailId) {
        this.getDetail()
      }
      // this.getSelect()
    },
    timeChange(time) {
      if (time) {
        this.form.serviceTimeBegin = time[0]
        this.form.serviceTimeEnd = time[1]
        this.calculateHours(time[0], time[1])
      }
    },
    // 查询下拉框
    getSelect() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['volunteer_recruit_type']
        })
        .then((res) => {
          if (res.success) {
            var state = res.result
            // let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = state['volunteer_recruit_type']
          } else {
            this.$message.error(res.message)
          }
        })
    },

    recruitmentTypeChange(val) {
      this.form.recruitmentType = this.recruitmentType.join(',')
    },

    setTypeList() {
      if (this.serviceType == 2 || this.serviceType == 4) {
        this.typeList = [
          { dictCode: '1', dictName: '正式志愿者' },
          { dictCode: '2', dictName: '预备志愿者' }
        ]
      } else if (this.serviceType == 3) {
        this.typeList = [
          { dictCode: '3', dictName: '学生志愿者' },
          { dictCode: '4', dictName: '小志愿者' },
          { dictCode: '5', dictName: '社会志愿者' }
        ]
      }
    },
    // 详情
    getDetail() {
      this.$api.volunteer
        .viewVolunteerRecruit({ id: this.detailId })
        .then((res) => {
          if (res.success) {
            this.form = res.result
            this.recruitmentType = res.result.recruitmentType.split(',')
            if (this.form.serviceTimeBegin && this.form.serviceTimeEnd) {
              this.value1 = [
                this.form.serviceTimeBegin,
                this.form.serviceTimeEnd
              ]
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleUploadSuccess(result) {
      this.imgUrl = result.attId
      this.form.mainPic = result.attPath
      if (this.form.mainPic) {
        this.$refs['form'].clearValidate(['mainPic'])
      }
      this.cropperModel = false
    },

    //封面设置
    uploadPicture() {
      if (this.pageType == 'detail') {
        return
      }
      let option = {
        cropWidth: '375',
        cropHeight: '215',
        imgUrl: this.form[`mainPic`]
      }
      this.$refs.cropperRef.initCropper(option)
    },
    // 保存
    fromSubmit(form) {
      console.log(this.serviceType)
      this.$refs[form].validate((vaild) => {
        if (vaild) {
          this.loadingSave = true
          let url = ''
          if (this.pageType === 'add') {
            url = 'addVolunteerRecruit'
            this.form.serviceType = this.serviceType
          } else {
            url = 'editVolunteerRecruit'
            this.form.id = this.detailId
          }
          this.$api.volunteer[url]({
            ...this.form
          })
            .then((res) => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'add') {
                  this.$message.success('新建招募活动成功')
                } else {
                  this.$message.success('编辑招募活动成功')
                }
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.value1 = []
      this.form = {}
      this.recruitmentType = []
      this.form.serviceTimeEnd = ''
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader-form {
  display: flex;
  flex-direction: column;
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .avatar-uploader {
    border: 1px dashed #8c939d;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .el-icon-plus {
      font-size: 20px;
    }

    .el-upload__text {
      line-height: 1;
    }
  }

  .uploader-form {
    width: 375px;
    height: 215px;
    display: flex;
    cursor: pointer;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px dashed #8c939d;
    img {
      width: 100%;
      height: 100%;
    }
    i {
      font-size: 34px;
    }
  }
}
</style>